var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"last-six-calls"},[_c('span',[_vm._v(_vm._s(this.$lang.game.rollercoaster.lastSixCallsTitle))]),_vm._v(" "),_c('ul',_vm._l((_vm.lastSixCalls),function(call){return _c('li',{key:call.callValue},[_c('img',{attrs:{"src":_vm.getPathToCallImage(call.callValue),"title":call.callName}})])}))]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39511530","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game/implementations/uk/roller-coaster/_components/last-six-calls/last-six-calls.html
// module id = null
// module chunks = 